import type { ReactElement } from 'react';
import { Route, Routes } from 'react-router';

import { AppShell } from '../components/layout/AppShell.js';
import { AuthLayout } from '../components/layout/AuthLayout.js';
import { CheckEmailPage } from '../routes/CheckEmailPage.js';
import { ForgotPasswordPage } from '../routes/ForgotPasswordPage.js';
import { HistoryPage } from '../routes/HistoryPage.js';
import { InsightsPage } from '../routes/InsightsPage.js';
import { InvitePage } from '../routes/InvitePage.js';
import { NotFoundPage } from '../routes/NotFoundPage.js';
import { OnboardingPage } from '../routes/OnboardingPage.js';
import { ResetPasswordPage } from '../routes/ResetPasswordPage.js';
import { SettingsPage } from '../routes/SettingsPage.js';
import { SignInPage } from '../routes/SignInPage.js';
import { SignUpPage } from '../routes/SignUpPage.js';
import { TodayPage } from '../routes/TodayPage.js';
import { VerifyEmailPage } from '../routes/VerifyEmailPage.js';
import { RequireFamily } from './RequireFamily.js';
import { RequireSession } from './RequireSession.js';
import { routePaths } from './route-paths.js';

export function AppRoutes(): ReactElement {
    return (
        <Routes>
            <Route element={<AuthLayout />}>
                <Route path={routePaths.signIn} element={<SignInPage />} />
                <Route path={routePaths.signUp} element={<SignUpPage />} />
                <Route path={routePaths.forgotPassword} element={<ForgotPasswordPage />} />
                <Route path={routePaths.resetPassword} element={<ResetPasswordPage />} />
                <Route path={routePaths.verifyEmail} element={<VerifyEmailPage />} />
                <Route path={routePaths.checkEmail} element={<CheckEmailPage />} />
                <Route element={<RequireSession />}>
                    <Route path={routePaths.onboarding} element={<OnboardingPage />} />
                    <Route path={routePaths.invite} element={<InvitePage />} />
                </Route>
            </Route>
            <Route element={<RequireSession />}>
                <Route element={<RequireFamily />}>
                    <Route element={<AppShell />}>
                        <Route index element={<TodayPage />} />
                        <Route path={routePaths.history} element={<HistoryPage />} />
                        <Route path={routePaths.insights} element={<InsightsPage />} />
                        <Route path={routePaths.settings} element={<SettingsPage />} />
                        <Route path="*" element={<NotFoundPage />} />
                    </Route>
                </Route>
            </Route>
        </Routes>
    );
}
